import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
export default function useBlogList() {
    const isBlogFormSidebarActive = ref(false)
    const blogData = ref(null);
    const contentsData = ref([]);
    const { t } = useI18nUtils()
    const blogs = ref([]);
    const toast = useToast()
    const refCatListTable = ref(null);
    const tableColumns = [
      { key: '', label: '', sortable: false },
      { key: 'cover_image', label: t('cover_image'), sortable: false, tdClass:'width-200 p-1' },
      { key: 'title', label: 'Title', sortable: false },
      { key: 'slug', label: 'Slug', sortable: false },
      { key: 'category_name', label:'Category Name', sortable:false},
      { key: 'is_active', label: 'Status', sortable: false },
      { key: 'action', label: '#', sortable: false },
    ]
    const perPage = ref(10)
    const totalBlogs = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const statusFilter = ref(null)
    const catFilter = ref(null);
    const catsData = ref([]);
    const dataMeta = computed(() => {
      const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
      const to = Math.min(
        totalBlogs.value,
        perPage.value * currentPage.value
      );
      return {
        from,
        to,
        of: totalBlogs.value,
      }
    })

    store.dispatch('app-blog/fetchCats', {})
    .then(response => {
      catsData.value = response.data.data
    })
    const refetchData = () => {
      fetchData()
    }
    watch([currentPage, perPage, searchQuery, statusFilter,catFilter], () => {
      fetchData()
    })
    const fetchData = (ctx, callback) => {
        // const offset = perPage.value*(currentPage.value-1);
        const getLocalSite = JSON.parse(localStorage.getItem('site'))
        store
          .dispatch('app-blog/fetchBlogs', {
            limit: perPage.value,
            // offset:offset,
            currentPage: currentPage.value,
            keywords: searchQuery.value,
            order_by:'ordering_count DESC',
            category_id:catFilter.value
          })
          .then(response => {
            blogs.value  = response?.data?.data || []
            const total = response?.data?.total
            totalBlogs.value = total
          })
    }
    const updateBlogsOrdering = ()=>{
      store.dispatch('app-blog/updateBlogsOrdering',blogs.value).then(response=>{})
    }
    const resolveCatStatusVariant = status => {
       
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }
    const resolveCatStatusnameVariant = status => {
       
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }
    const updateBlog = async (data) => {
      if(data){
        blogData.value = data
      } else {
        blogData.value = null;
      }
      
      isBlogFormSidebarActive.value = true;
    }
    
    const deleteData = (id) => {
        //fetchDeleteProperty
        store.dispatch('app-blog/deleteBlog',id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete Blog",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
    
        })
      }
      
    return {
        isBlogFormSidebarActive,
        blogData,
        refCatListTable,
        tableColumns,
        perPage,
        totalBlogs,
        currentPage,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        statusFilter,
        dataMeta,
        refetchData,
        fetchData,
        resolveCatStatusVariant,
        resolveCatStatusnameVariant,
        updateBlog,
        deleteData,
        catsData,
        catFilter,
        t,
        updateBlogsOrdering,
        blogs

    }
}